import { render, staticRenderFns } from "./detail-item.vue?vue&type=template&id=44759188&scoped=true"
import script from "./detail-item.vue?vue&type=script&lang=ts"
export * from "./detail-item.vue?vue&type=script&lang=ts"
import style0 from "./detail-item.vue?vue&type=style&index=0&id=44759188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44759188",
  null
  
)

export default component.exports